import { render, staticRenderFns } from "./user-wallet-message.vue?vue&type=template&id=25d7876f&"
import script from "./user-wallet-message.vue?vue&type=script&lang=js&"
export * from "./user-wallet-message.vue?vue&type=script&lang=js&"
import style0 from "./user-wallet-message.vue?vue&type=style&index=0&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports